import { get, post, del } from '../util/http';
import { ENDPOINTS } from '../util/endpoints';

export const pointService = {
  search:          (params)        => get(ENDPOINTS.points.search, { params }),
  searchUnassigned:(params)        => get(ENDPOINTS.points.unassignedSearch, { params }),
  getByDevice:     (deviceId)      => get(ENDPOINTS.points.byDevice(deviceId)),
  assignDevice:    (pointId, data) => post(ENDPOINTS.points.assignDevice(pointId), data),
  unassignDevice:  (pointId)       => del(ENDPOINTS.points.unassignDevice(pointId)),
};
